import React, { useState, useEffect } from 'react';
import { formatDuration } from 'date-fns/formatDuration';
import './Time.scss';

interface TimeProps {
  expires?: number;
  onRefresh?: () => void;
  onExpired?: () => void;
}

const DEFAULT_ON_REFRESH = () => {};
const DEFAULT_ON_EXPIRED = () => {};

export function Time({
  expires = 0,
  onExpired = DEFAULT_ON_EXPIRED,
  onRefresh = DEFAULT_ON_REFRESH,
}: TimeProps) {
  const [time, setTime] = useState(expires);
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  const hours = Math.floor(time / 3600);

  useEffect(() => {
    setTime(expires);
  }, [expires]);

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout> | undefined;

    if (time > 0) {
      timeout = setTimeout(() => {
        setTime(time => {
          const next = time - 1;
          if (next < 0) {
            return 0;
          }

          return next;
        });
      }, 1000);
    } else {
      onExpired();
    }

    return function cleanup() {
      clearTimeout(timeout);
    };
  }, [time]);

  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | undefined;
    if (expires > 10) {
      interval = setInterval(function () {
        onRefresh();
      }, 10000);
    }
    return function cleanup() {
      clearInterval(interval);
    };
  }, [expires]);

  if (expires <= 0) {
    return null;
  }

  if (time <= 0) {
    return null;
  }

  return (
    <div className="time">
      {formatDuration({ hours, minutes, seconds }, { zero: false })}
    </div>
  );
}

export default Time;
